import React, { memo } from 'react';
import cx from 'classnames';
import { displayAmount } from 'pages/newaftersale/return/utils';

import './index.scss';

interface Props {
    className?: string;
    amount: number;
}

const Amount: React.FC<Props> = memo((props) => {
    return (
        <div className={cx('amount', props.className)} style={{ whiteSpace: 'nowrap' }}>
            <span>&yen;</span>
            <span>{displayAmount(props.amount || 0)}</span>
        </div>
    );
});

export default Amount;
